import React, { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';

const CustomConfigPopover = lazy(
  () => import(/* webpackChunkName: "owner" */ '../../CustomConfigPopover')
);

type Props = any;

const CustomConfigPopoverLazy: React.FC<Props> = props => {
  return (
    <Suspense fallback={<WidgetConfigPopover isLoading onClose={() => null} />}>
      <CustomConfigPopover {...props} />
    </Suspense>
  );
};
CustomConfigPopoverLazy.displayName = 'CustomConfigPopoverLazy';

export default CustomConfigPopoverLazy;
